import { motion } from "framer-motion"
import { Link } from 'react-router-dom'
import projects from "./Projects.json"

const cardVariants = {
    offscreen: {
      y: 300
    },
    onscreen: {
      y: 50,
      rotate: -10,
      transition: {
        type: "spring",
        bounce: 0.4,
        duration: 0.8
      }
    }
}

function Card({ coverImage, id, }) {
    // const background = `linear-gradient(306deg, ${hue(hueA)}, ${hue(hueB)})`
    const background = `linear-gradient(306deg, #7f81f2, #7f81f2)`
    return (
        <motion.div className="card-container" initial="offscreen" whileInView="onscreen" viewport={{ once: true, amount: 0.8 }}>      
                <div className="splash" style={{ background }} />
                <motion.div className="card" variants={cardVariants}>
                    <img src={coverImage} className="" alt="cover" />
                </motion.div>
        </motion.div>
    );
}

const Portfolio = () => {
    const scrollToTop = () => {
        window.scrollTo({
            top: 0,
            behavior: 'smooth'
        })
    }

    return (
        <div>
            <div className="p-10">
                <h1 className="h1-macro no-selection">Portfolio</h1>
            </div>
            <div className="flex flex-wrap justify-center gap-16 w-full mt-10 pb-40">
                {projects.map(({id, gallery, title, coverImage}, index) => {
                    return (
                        <Link to={`/portfolio/${id}`} key={index} onClick={() => scrollToTop()} state={{ title: title, gallery: gallery }}>
                            <motion.div initial={{ opacity: 0 }} whileInView={{ opacity: 1 }} viewport={{ once: true }}>
                                    <Card coverImage={coverImage} key={coverImage} />
                            </motion.div>
                        </Link>
                    )
                })}
            </div>
        </div>
    );
}

export default Portfolio;